import React, { useEffect, useState } from "react";
import { Modal, Table, Spinner, Badge } from "react-bootstrap";
import * as cobrosFamiliaApi from "../../api/cobrosFamilia";
import { formatoNumero } from "../../utils/moneda";

/** Muestra el detalle de un cobro: si es Tarjeta, los gastos esporádicos incluidos;
 * en ambos casos, el historial de amortizaciones registradas. */
export default function ModalDetalleCobro({ show, onHide, cobroId }) {
  const [detalle, setDetalle] = useState(null);
  const [cargando, setCargando] = useState(true);

  useEffect(() => {
    if (show && cobroId) {
      setCargando(true);
      cobrosFamiliaApi.obtenerDetalle(cobroId).then(setDetalle).finally(() => setCargando(false));
    }
  }, [show, cobroId]);

  const cobro = detalle?.cobro;

  return (
    <Modal show={show} onHide={onHide} centered size="lg">
      <Modal.Header closeButton>
        <Modal.Title style={{ fontSize: "1.1rem" }}>Detalle del cobro</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {cargando || !detalle ? <Spinner animation="border" /> : (
          <>
            <p className="mb-1"><strong>{cobro.deudor}</strong></p>
            <p className="text-muted mb-1">{cobro.descripcion}</p>
            <p className="mb-3">
              Monto: <strong>${formatoNumero(cobro.monto)}</strong>{" "}
              &middot; Amortizado: <strong className="text-fs-ingreso">${formatoNumero(cobro.totalAmortizado)}</strong>{" "}
              &middot; Saldo: <strong className="text-fs-gasto">${formatoNumero(cobro.saldoPendiente)}</strong>{" "}
              <Badge
                bg={cobro.estado === "Cancelada" ? "success" : cobro.estado === "En espera" ? "secondary" : "warning"}
                text={cobro.estado === "Pendiente" ? "dark" : undefined}
                className="ms-1"
              >
                {cobro.estado}
              </Badge>
            </p>

            {cobro.tipo === "TarjetaCredito" && (
              <>
                <h6>Gastos esporádicos incluidos</h6>
                <Table size="sm" hover className="table-fs mb-3">
                  <thead><tr><th>Motivo</th><th>Fecha</th><th className="text-end">Monto</th></tr></thead>
                  <tbody>
                    {detalle.detalle.map((d) => (
                      <tr key={d.gastoEsporadicoId}>
                        <td>{d.motivo}</td>
                        <td>{new Date(d.fecha).toLocaleDateString("es-ES")}</td>
                        <td className="text-end">${formatoNumero(d.monto)}</td>
                      </tr>
                    ))}
                    {!detalle.detalle.length && (
                      <tr><td colSpan={3} className="text-center text-muted py-2">Sin gastos.</td></tr>
                    )}
                  </tbody>
                </Table>
              </>
            )}

            <h6>Historial de amortizaciones</h6>
            <Table size="sm" hover className="table-fs">
              <thead><tr><th>Fecha</th><th>Registrado por</th><th className="text-end">Monto</th></tr></thead>
              <tbody>
                {detalle.amortizaciones.map((a) => (
                  <tr key={a.amortizacionId}>
                    <td>{new Date(a.fecha).toLocaleDateString("es-ES")}</td>
                    <td>{a.registradoPor}</td>
                    <td className="text-end">${formatoNumero(a.monto)}</td>
                  </tr>
                ))}
                {!detalle.amortizaciones.length && (
                  <tr><td colSpan={3} className="text-center text-muted py-2">Sin abonos registrados.</td></tr>
                )}
              </tbody>
            </Table>
          </>
        )}
      </Modal.Body>
    </Modal>
  );
}
